import { VacancyAdvice } from 'src/types/vacancyAdvices';

export enum VacancyAdviceGroup {
    Important,
    Paid,
    Free,
}

export const VacancyAdviceToGroup: Record<VacancyAdvice, VacancyAdviceGroup> = {
    [VacancyAdvice.SalaryAboveMarket]: VacancyAdviceGroup.Important,
    [VacancyAdvice.SalaryCloserToMarket]: VacancyAdviceGroup.Important,
    [VacancyAdvice.SalaryMoreSpecific]: VacancyAdviceGroup.Important,
    [VacancyAdvice.PublishSalary]: VacancyAdviceGroup.Important,
    [VacancyAdvice.ChangeVacancyName]: VacancyAdviceGroup.Important,
    [VacancyAdvice.UseResumeSearch]: VacancyAdviceGroup.Paid,
    [VacancyAdvice.UseSearchTop]: VacancyAdviceGroup.Paid,
    [VacancyAdvice.UseStandardPlus]: VacancyAdviceGroup.Paid,
    [VacancyAdvice.WorkAddress]: VacancyAdviceGroup.Free,
    [VacancyAdvice.ConditionsToDescription]: VacancyAdviceGroup.Free,
    [VacancyAdvice.RequirementsToDescription]: VacancyAdviceGroup.Free,
    [VacancyAdvice.ResponsibilitiesToDescription]: VacancyAdviceGroup.Free,
    [VacancyAdvice.EmployerContacts]: VacancyAdviceGroup.Free,
    [VacancyAdvice.DecreaseWorkExperience]: VacancyAdviceGroup.Free,
    [VacancyAdvice.RaiseVacancy]: VacancyAdviceGroup.Paid,
};

export const HIDE_ADVICE_URL = '/shards/employer/vacancies/advice/hide';

export enum Rating {
    Sad = '1',
    Halfsad = '2',
    Neutral = '3',
    Halfsmile = '4',
    Smile = '5',
}

export enum Reason {
    Difficult = 'difficult',
    Paid = 'paid',
    DontBelieve = 'dontBelieve',
    Disagree = 'disagree',
    NotRelevant = 'notRelevant',
    CantApply = 'cantApply',
    Errors = 'errors',
}

export const SALARY_VACANCY_ADVICES: VacancyAdvice[] = [
    VacancyAdvice.PublishSalary,
    VacancyAdvice.SalaryCloserToMarket,
    VacancyAdvice.SalaryAboveMarket,
    VacancyAdvice.SalaryMoreSpecific,
];

export const NO_PERCENT = '-';

/** Событие вызванные в сервисе где размещен прокси-компонента */
export const VACANCY_ADVICE_MODAL_SOURCE_EVENT = 'HH-PROXY-VACANCY_ADVICE_MODAL_SOURCE_EVENT';
/** Событие вызываемые прокси-компонентом */
export const VACANCY_ADVICE_MODAL_COMPONENT_EVENT = 'HH-PROXY-VACANCY_ADVICE_MODAL_COMPONENT_EVENT';
/** Типы событий которыми обменяваются сервис и прокси-компонент */
export enum VacancyAdviceModalEventType {
    Init = 'HH-PROXY-VACANCY_ADVICES_MODAL_INIT',
    SetData = 'HH-PROXY-VACANCY_ADVICES_MODAL_SET_DATA',
    SetAdvice = 'HH-PROXY-VACANCY_ADVICES_MODAL_SET_ADVICE',
    SetRating = 'HH-PROXY-VACANCY_ADVICES_MODAL_SET_RATING',
    OpenProlangateModal = 'HH-PROXY-VACANCY_ADVICES_MODAL_OPEN_PROLANGATE_MODAL',
    SendFeedback = 'HH-PROXY-VACANCY_ADVICES_MODAL_SEND_FEEDBACK',
}

export interface FormValues {
    reasons: Reason[];
    comment: string;
}

export const DEFAULT_FORM_VALUES: FormValues = {
    reasons: [],
    comment: '',
};
